import { logisticsAsset, logisticsSafety, manufacturingSteel } from "@pages/Enterprise/Solution/components/Banner/BannerImages";
import productImg from "../main/product/productImg";
import productPurchase from "../main/product/productPurchase";

export default {
  desc: '여러분은 전 세계에서 온 패키지가 어떻게 며칠 만에 여러분의 손에 도착하는지 궁금해한 적이 있나요? 그 비결은 바로 물류와 공급망 관리에 있습니다. 이 두 가지는 현대 경제에서 필수적인 기둥입니다. 정보 기술(IT)의 지원으로 이러한 과정은 혁신을 거듭하며 기업에 뛰어난 효율성을 제공하고 있습니다. 그렇다면 물류와 공급망 관리란 무엇이고, 어떻게 작동하며, 디지털 시대에 왜 중요한가요? 이 글을 통해 함께 알아봅시다!',
  keywords: '물류 및 공급망 관리, Logistics,공급망 관리, AI, IoT, RTLS',
  ogSite: '물류와 공급망 관리 (Logistics and Supply Chain Management)란 무엇인가요?',
  title: '물류와 공급망 관리 (Logistics and Supply Chain Management)란 무엇인가요?',
  ogUrl: 'https://orbro.io/blog/logistics-and-supply-chain-management',
  ogImg: 'https://lh3.googleusercontent.com/fife/ALs6j_ENH-sLhjxjs695-Eoeg9UkURScfDKDjaWqOkT-iFpBpa1LkmjOd_OqY3LwdS8cCdesOp6ZLY_eyioJBJXdhSZ_j5_UoAomTT1otwQodWK0nwo-sZ40rHXCQ5dLfnujURs8hVUo38fs1_0O4k0peEUi74IVKiV6JIb1eu1wzSyoPMzCfaWZuNzEN3hTKEkdLorsWe8cTLxHyTGoseQfv9Gh3u26FuUEen9CWiZd7ariARyLyb4G-BQSWj38vUwc5auLTvQWEfeUDr3H5JgofRWWcKWLbGZbzLqyoNnRPj59uhhy6WPDbHJINydml_8hAmbUR6mldLzNFLCmIyQfO6CqW6F1y-p-NwdeMTAQDgntA6aVPlWAu5RXbJ4pYK3Z0XTbFRctE4DBuXWc_pmTcu7xOIxGE04uv48fWKSimj2Isu8eECrUd95PH92z_mMy1O9YBXwa8zPXsFAkJo7E-e603tgLjW7TEZv06CNCxTOXS9WE55811S7_anH9lvVy5lxBBxF_tPfm4vrDBsstU0LBxg14Jatynp2hp3Kf8qMESVDhzi7BImwk5wfPmq-bn16f4J317_I3YUdFje9L0g2VhbMboPrlhpld4eEv0nu2BOFX94Vj1aJQyeXO6izkHJjkycy0ohDASBFk8mePBenhbFclcX4H9I2vw8LAiU-TN2aFd0M9LI-OHlWKLunEFC9KMbGk647hToYRfWMOXVj4UDBsBlvyJ_w7m7cDq2cEfgzmWKENOe9atUHsOQiP6lpOpdlqHqEfafGXCDuKBo3bVJhpuuALCM_0e9UH8-C8CasCflcSZDauv7tp0tqrmKPcgTjDVOY5llBNM-AlzuHRx2BEEN4JUJbirdLo4ihQKPGl1pccniave3jZVOenUC5KktCeaVS5cnDoDopY_3ocIM6L0RGG921kgc-9D27IpX939zWUrF4tz4B9yiorB1htxtxOifOU7aViBW13ZDVa7f12CkIbWjtEbEPeuYS90_6m9vMT8IO8bug0_QE8A5q2hSkYnVwDUdtXEr0zAON0nQZ__JQVuHeul7UtmrjwKBTJyPAUlbdhYuHcPTXUohGNF6WCpzOrTQrTFxyKEOmOyb2isUlDkttw-8H2--xEBxlh71t_smZ0tOQfBr6CCf1mHES2W6nGGAzlDJ2MOV3Efl6X4AWORSBPr2gbdQLM4XXk9I_lVvqvroECKqrIOhcSjr6gDq_7lLnnFGcaEHBxIsNJm7cak5k2_3nAYT_psMWDpSmuGKkkMHLDIeBGgFmUs6GXYOLHfaLKErQHZ11stMYd_aNVm08bSlH328x8VT-4q0CqhNJhEU1IT-JOn3Wfced83fN6PH2dfv0jAGvUk9wwBSqp1Ztdg8fDmNyqeCQg8ozRhtMpMGHQlTTG1yyUIgfiVel-dNS_6BPJk6Xn_7jP7dSgBpnwa3dGk8nTFTyivhboGQ8aXA2vAvcyNYF4KkPD_l-EEPFX1vPIGl4L1LUosYIghYbEdUcXI_ds3HmfLRoXjAsS8fKHQJgDPzxP6YKVGEDQcsXpypMdzNy6umiPlIHTZ5vhk4id_XmYB7esNwIewilRtApDRYKWxPfAW4_24FEZNekuYjpnqnEbVNi3Z-ptDu4f=w1416-h1412?auditContext=forDisplay',
  ogType: 'website',
  date: '2025-07-08',
  tag1: '#Logistics',
  tag2: '#물류및공급망 관리',
  tag3: '#공급망관리',
  tag4: '#AI #IoT #RTLS',
  text: [
    {
      head: '',
      subHead: '',
      desc: '여러분은 전 세계에서 온 패키지가 어떻게 며칠 만에 여러분의 손에 도착하는지 궁금해한 적이 있나요? 그 비결은 바로 물류와 공급망 관리에 있습니다. 이 두 가지는 현대 경제에서 필수적인 기둥입니다. 정보 기술(IT)의 지원으로 이러한 과정은 혁신을 거듭하며 기업에 뛰어난 효율성을 제공하고 있습니다. 그렇다면 물류와 공급망 관리란 무엇이고, 어떻게 작동하며, 디지털 시대에 왜 중요한가요? 이 글을 통해 함께 알아봅시다!',
      dot: ''
    },
    {
      head: '1. 물류와 공급망 관리 (Logistics and Supply Chain Management)란 무엇인가요?',
      subHead: '',
      desc: '물류(Logistics)는 상품, 서비스, 정보의 운송, 보관을 계획하고 실행하며 제어하는 과정으로, 효율성과 비용 절감을 보장합니다. 이는 운송, 창고 관리, 포장, 재고 관리와 같은 활동을 포함합니다.\n\n공급망 관리(Supply Chain Management, SCM)는 원자재부터 완제품이 고객의 손에 닿기까지의 전체 활동을 조정하는 것입니다. SCM은 물류뿐만 아니라 공급업체, 제조업체, 유통업체와의 협력을 포함해 상품, 정보, 재정의 흐름을 최적화합니다.\n\n기술 시대에 물류와 공급망 관리는 AI, IoT, 관리 소프트웨어와 같은 IT 솔루션으로 강화되어 기업이 원활하게 운영되고 고객의 요구에 신속하게 대응할 수 있도록 돕습니다.\n\n예시: 쿠팡과 같은 전자상거래 회사는 물류와 공급망 관리를 통해 창고에서 고객에게 24시간 내에 상품을 배송하며, 실시간 추적 시스템과 데이터 분석을 활용합니다.',
      dot: ''
    },
    {
      head: '2. 물류와 공급망 관리는 어떻게 작동하나요?',
      subHead: '',
      desc: '물류와 공급망 관리의 프로세스는 다음과 같은 주요 단계로 나눌 수 있습니다.\n\n• 계획 수립: 시장 수요를 예측하고, 공급원을 결정하며, 운송 및 보관 계획을 세웁니다.\n\n• 공급: 공급업체로부터 원자재를 구매하고, 품질과 납기를 보장합니다.\n\n• 생산: 원자재를 완제품으로 변환하고, 생산 프로세스를 최적화합니다.\n\n• 운송 및 유통: 공장에서 창고로, 그리고 고객에게 상품을 이동시킵니다.\n\n• 정보 관리: 소프트웨어를 사용해 재고부터 배송 상태까지 데이터를 추적합니다.\n\n• 피드백 및 개선: 고객 피드백을 수집하고 프로세스를 조정해 효율성을 높입니다.\n\nIT 기술은 IoT를 통한 상품 추적부터 AI를 통한 시장 수요 예측까지 이러한 단계를 연결하는 데 중심 역할을 합니다.\n\n예시: 물류 회사는 IoT 센서를 사용해 냉동 상품의 온도를 실시간으로 추적하여 상품 품질을 보장합니다.',
      dot: ''
    },
    {
      head: '3. 물류 및 공급망 관리에서 IT 기술의 역할',
      subHead: '',
      desc: '정보 기술은 물류와 공급망 관리의 운영 방식을 변화시키고 있습니다. 다음은 주요 IT 기술입니다.\n\n• 사물인터넷(IoT)\n기능: 트럭, 컨테이너, 상품에 부착된 IoT 센서가 위치, 온도, 상태를 실시간으로 추적합니다.\n이점: 손실 위험 감소, 상품 품질 보장, 운송 경로 최적화.\n예시: 운송 회사는 IoT를 사용해 컨테이너의 위치를 추적하여 제시간에 배송을 보장합니다.\n\n• 인공지능(AI) 및 머신러닝\n기능: 데이터를 분석해 수요를 예측하고, 경로를 최적화하며, 위험을 감지합니다.\n이점: 운영 비용 절감 및 고객 경험 개선.\n예시: AI는 설날 쇼핑 수요를 예측해 기업이 적절한 재고를 준비하도록 돕습니다.\n\n• 공급망 관리 소프트웨어\n기능: 공급업체, 창고, 운송의 데이터를 하나의 플랫폼에 통합합니다.\n이점: 투명성 증가, 이해관계자 간 협력 개선.\n예시: SAP 소프트웨어는 기업이 공장에서 고객까지 전체 공급망을 추적할 수 있게 합니다.\n\n• 블록체인\n기능: 공급망 거래의 투명성과 보안을 보장합니다.\n이점: 사기 방지, 상품 출처 추적.\n예시: 식품 회사는 블록체인을 사용해 유기농 상품의 출처를 증명합니다.\n\n• 실시간 위치 추적 시스템(RTLS)\n기능: RFID, Wi-Fi, GPS 기술을 사용해 창고나 도로에서 상품과 트럭의 위치를 추적합니다.\n이점: 상품 검색 시간 단축, 창고 효율성 증대.\n예시: 대형 창고는 RTLS를 사용해 몇 초 만에 팔레트를 찾습니다.',
      dot: ''
    },
    {
      head: '4. 물류 및 공급망 관리의 이점',
      subHead: '',
      desc: '물류와 공급망 관리는 IT 기술과 결합되어 다음과 같은 실질적인 가치를 제공합니다.\n\n• 운영 효율성 증대\n운송 경로 최적화, 배송 시간 단축, 재고 관리 효율화.\n예시: 물류 회사는 AI를 사용해 경로를 최적화하여 배송 시간을 20% 단축합니다.\n\n• 비용 절감\n실시간 데이터를 통해 창고, 운송, 생산에서의 낭비를 줄입니다.\n예시: 기업은 정확한 재고 관리로 매년 수십억 원을 절약합니다.\n\n• 고객 경험 개선\n배송 상태에 대한 투명한 정보를 제공해 고객 만족도를 높입니다.\n예시: 고객은 앱을 통해 정확한 배송 시간을 알림받습니다.\n\n• 지속 가능성 증대\n운송과 에너지 사용을 최적화해 탄소 배출을 줄입니다.\n예시: 운송 회사는 전기차로 전환하고 디지털 트윈을 사용해 경로를 최적화하여 배출량을 15% 줄입니다.\n\n• 투명성 보장\n블록체인과 같은 기술로 상품의 출처와 여정을 추적해 고객의 신뢰를 높입니다.\n예시: 커피 브랜드는 블록체인을 사용해 지속 가능한 농장에서 온 상품임을 증명합니다.',
      dot: ''
    },
    {
      head: '5. 물류 및 공급망 관리의 실제 응용',
      subHead: '',
      desc: '물류와 공급망 관리는 다양한 분야에서 효과를 발휘합니다.\n\n• 전자상거래\n창고에서 고객에게 빠르고 정확한 배송을 보장합니다.\n예시: Lazada는 물류와 공급망 관리를 사용해 대도시에서 당일 배송을 제공합니다.\n\n• 제조\n생산 프로세스, 원자재, 완제품 관리를 최적화합니다.\n예시: 자동차 공장은 RTLS를 사용해 부품을 추적하고 조립 시간을 단축합니다.\n\n• 의료\n의료 장비, 의약품, 물자를 관리해 적시 공급을 보장합니다.\n예시: 병원은 디지털 트윈을 사용해 MRI 기계를 추적하고 유지보수 시기를 예측합니다.\n\n• 소매\n고객 수요를 분석하고 재고를 관리해 부족이나 과잉을 방지합니다.\n예시: 슈퍼마켓은 AI를 사용해 식품 수요를 예측하고 선반을 항상 채워둡니다.\n\n• 농업\n농산물의 출처를 추적해 농장에서 식탁까지 품질을 보장합니다.\n예시: 과일 수출 회사는 블록체인을 사용해 국제 표준을 충족하는 상품임을 증명합니다.',
      dot: ''
    },
    {
      head: '6. 물류 및 공급망 관리의 미래',
      subHead: '',
      desc: '기술의 발전으로 물류와 공급망 관리는 혁신적인 변화를 맞이하고 있습니다.\n\n• 완전 자동화: 자율주행차와 드론 배송이 운송 방식을 변화시킬 것입니다.\n\n• 고급 AI: 시장 수요를 더 정확하게 예측하고 프로세스를 최적화합니다.\n\n• 블록체인 보편화: 전체 공급망에서 투명성과 보안을 보장합니다.\n\n• 더 지속 가능: 재생 에너지와 친환경 기술을 사용해 환경 영향을 줄입니다.\n\n예시: 미래에는 AI가 제어하는 드론이 30분 내에 패키지를 배송하고, 배출량을 줄일 수 있습니다.',
      dot: ''
    },
    {
      head: '7. 결론',
      subHead: '',
      desc: '물류와 공급망 관리는 경제의 중추일 뿐만 아니라, 디지털 시대에 기업의 발전을 촉진하는 원동력입니다. AI, IoT, 블록체인, RTLS와 같은 IT 기술의 지원으로 이러한 프로세스는 더욱 스마트하고, 효율적이며, 지속 가능해지고 있습니다. 공급망을 최적화하거나 비즈니스 효율성을 높이고 싶다면, 지금 바로 기술 솔루션을 탐구해 보세요!',
      dot: ''
    }
  ],

  link: {
    page: 'rtls',
    numb: '1',
    product: [
      {
        text: productPurchase.purchase.ble.bleStarterKit.title,
        title: productPurchase.purchase.ble.bleStarterKit.title,
        serial: productPurchase.purchase.ble.bleStarterKit.serial,
        desc: 'UWB 단말기를 작업자 또는 장비에 부착하여, 실시간으로 위치 추적을 돕는 제품입니다.',
        img: productImg.product.bleStarterKit.key1,
      },
      {},
    ],
    solution: [
      {
        img: logisticsAsset.thumb,
        data: 'logisticsAsset',
        link: '/enterprise/logistics/asset',
      },
      {
        img: logisticsSafety.thumb,
        data: 'logisticsSafety',
        link: '/enterprise/logistics/safety',
      },
      {
        img: manufacturingSteel.thumb,
        data: 'manufacturingSteel',
        link: '/enterprise/manufacturing/steel',
      },
    ],
  },
};
